/*
 * TASK TEXT FIELDS
 *
 * Presents task title and notes as separate accessible fields inside one joined surface.
 *
 * Recent changes:
 * - Added the joined title-and-notes treatment shared by every task form popup.
 * - Delegates the visual treatment to the shared popup joined-fields pattern.
 * - Names the visible task-textarea help text `Task Details` without changing its stored notes value.
 */

import { JoinedTextFields } from '../../popup';

interface TaskTextFieldsProps {
  idPrefix: string;
  title: string;
  notes: string;
  onTitleChange: (value: string) => void;
  onNotesChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  invalid?: boolean;
  notesRows?: number;
}

export default function TaskTextFields({
  idPrefix,
  title,
  notes,
  onTitleChange,
  onNotesChange,
  disabled = false,
  required = true,
  invalid = false,
  notesRows = 9,
}: TaskTextFieldsProps) {
  return (
    <JoinedTextFields
      idPrefix={idPrefix}
      groupLabel="Task"
      titleLabel="Task title"
      bodyLabel="Notes"
      titlePlaceholder="Task title"
      bodyPlaceholder="Task Details"
      title={title}
      body={notes}
      onTitleChange={onTitleChange}
      onBodyChange={onNotesChange}
      disabled={disabled}
      requiredTitle={required}
      invalid={invalid}
      bodyRows={notesRows}
      bodyIdSuffix="notes"
    />
  );
}
